import { render, staticRenderFns } from "./BalanceOnHold.vue?vue&type=template&id=8ca54916"
import script from "./BalanceOnHold.vue?vue&type=script&lang=js"
export * from "./BalanceOnHold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports